import Typewriter from 'typewriter-effect';
import Button from '../Button';
import { ButtonContainer, HeroContainer, HeroImage, SubInter, SubTitle } from './style';
import { CONTACTS, COMPANY_NAME } from '../../constants';

const TYPEWRITER_STRINGS = [
  `${COMPANY_NAME} - Gestão Trabalhista e Consultoria`,
  'Simplificando o RH da sua empresa com eficiência e segurança jurídica.',
] as const;

const TYPEWRITER_CONFIG = {
  autoStart: true,
  loop: true,
  delay: 50,
  cursor: '',
};

const Hero = () => (
  <HeroContainer id="hero">
    <HeroImage>
      <SubTitle>
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(TYPEWRITER_STRINGS[0])
              .pauseFor(3000)
              .deleteAll(30)
              .typeString(TYPEWRITER_STRINGS[1])
              .pauseFor(2000)
              .deleteAll(30)
              .start();
          }}
          options={TYPEWRITER_CONFIG}
        />
      </SubTitle>
      <SubInter>
        Gestão inteligente de Recursos Humanos e rotinas trabalhistas para construtoras, empreiteiras e
        prestadores de serviço.
      </SubInter>
    </HeroImage>

    <ButtonContainer>
      <Button href="#services" color="blue">
        Conheça nossos serviços
      </Button>
      <Button color="wpp" href={CONTACTS.WHATSAPP.url} target="_blank" rel="noopener noreferrer">
        Fale conosco
      </Button>
    </ButtonContainer>
  </HeroContainer>
);

export default Hero;
